import { ReactComponent as DownloadIco } from '../../assets/download.svg'
import { ReactComponent as StatementIco } from '../../assets/statement.svg'
import { convertedStatementItemProps } from '../Statements'
import { Button, CircularProgress } from '@mui/material'
import { authSessionSlice } from '@/stores/auth'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useMutateStmtSoaDocMsDownloadApi } from '@/api'
import { useState } from 'react'

interface StatementReportProps {
  _statements: convertedStatementItemProps[]
}

const { setIsUserIdle } = authSessionSlice.actions

const StatementReport = ({ _statements }: StatementReportProps) => {
  const { t } = useTranslation('reportsPage')
  const dispatch = useDispatch()
  const [downloadingDocId, setDownloadingDocId] = useState<string | null>(null)

  const { mutateAsync } = useMutateStmtSoaDocMsDownloadApi()

  const handleDownload = async (docId?: string, statementUrl?: string) => {
    try {
      if (statementUrl) {
        window.open(statementUrl, '_blank', 'noopener,noreferrer')
        return
      }
      if (docId) {
        setDownloadingDocId(docId)
        const response = await mutateAsync(docId)
        if (response?.url) {
          window.open(response?.url, '_blank', 'noopener,noreferrer')
        } else {
          console.error('Failed to get the download Url')
        }
      }
    } catch (err) {
      console.error('Download API failed')
    } finally {
      setDownloadingDocId(null)
    }
  }

  return (
    <>
      {_statements.map(({ month, items: dItems }, mIdx) => (
        <div className='w-[60%] bg-white mt-4'>
          <div
            key={`${month}-${mIdx}`}
            className='p-4 border rounded-md bg-gray-50 hover:bg-gray-100'
          >
            <span className='flex gap-4 items-center mb-5 font-bold'>
              <StatementIco />
              {t(month, { ns: 'months' })}
            </span>
            {dItems.map(({ dateStr, items: sItems }, dIdx) => {
              return (
                <div
                  key={`${month}-${mIdx}-${dateStr}-${dIdx}`}
                  className='mb-2'
                >
                  <div className='text-sm leading-[22px] mb-2'>{dateStr}</div>
                  {sItems.map(
                    ({ statementType, statementUrl, statementId }, sIdx) => {
                      return (
                        <Button
                          key={`${month}-${mIdx}-${dateStr}-${dIdx}-${statementType}-${sIdx}`}
                          endIcon={
                            downloadingDocId === statementId ? (
                              <CircularProgress size={16} color='inherit' />
                            ) : (
                              <DownloadIco />
                            )
                          }
                          className='w-full bg-pi-sky-blue-1 hover:bg-pi-sky-blue-2 py-3 px-4 mb-2'
                          onClick={() => {
                            dispatch(setIsUserIdle())
                            handleDownload(statementId, statementUrl)
                          }}
                        >
                          <span className='grow text-left font-normal text-pi-dark-prussian-blue'>
                            {t(statementType || '', {
                              ns: 'statementTypes',
                            })}
                          </span>
                        </Button>
                      )
                    }
                  )}
                </div>
              )
            })}
          </div>
        </div>
      ))}
    </>
  )
}

export default StatementReport
